// ✅ done
// ❗ better authentication check other than res?.detail === "Invalid token."

import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import vectorArt from "../../assets/login-vector-art.png";
import logo from "../../assets/top-nav-logo.svg";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch } from 'react-redux'
import { loginAttempt } from '../features/user/user'
import { JService } from '../api-service/ApiService'
import { CCDropdown, CustomInput } from '../design/components/customComponents'
import Button from '../design/Button'
import { enqueueSnackbar } from 'notistack'
import { validatePhoneNumber } from '../../utility-functions'

const emailRegex = new RegExp(/^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,15}$/)
const stringFieldValidation = (val) => Boolean(val) && !!String(val).trim().length

const validationMapping = {
    "email" : {
        validate: (val) => emailRegex.test(val),
        error: (val) => "Please enter your business email",
    },
    "first_name": {
        validate: (val) => stringFieldValidation(val) && val.trim().length > 0 && val.trim().length <= 150,
        error: (val) => val.trim().length > 150 ? "Max characters allowed: 150": "This is a required field"
    },
    "last_name": {
        validate: (val) => stringFieldValidation(val) && val.trim().length > 0 && val.trim().length <= 150,
        error: (val) => val.trim().length > 150 ? "Max characters allowed: 150": "This is a required field"
    },
    "phone_number": {
        validate: (val) => val?.trim()?.length >= 0 && validatePhoneNumber(null, val),
        error: (val) => "Invalid phone number"
    },
    "password": {
		validate: (val) => val?.length >= 6,
		error: (val) => "Invite code too short, expected length 6"
	},
    "country_code": {
        validate: (val) => stringFieldValidation(val) && val.trim().length > 0 && validatePhoneNumber(null, val),
        error: (val) => "Invalid phone number"
    }
}
function Invite()
{
    const API_BASE_URL = process.env.REACT_APP_BETA
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loginValues, setLoginValues] = useState({
        first_name: {value:'',error:null},
        last_name: {value:'',error:null},
        email: {value:'',error:null},
        password: {value:'',error:null},
        phone_number:{value:'',error:null},
        country_code:{value:'+91',error:null}
    })
	const [isDisabled, setIsDisabled] = useState(true)

    const handleLoginChange = (e, field, value) => {
        const _field = e?.target?.name ?? field;
        let _value = e?.target?.value ?? value;
        let valueToValidate = _value;
		if(_field === "email") {
            valueToValidate = _value.toLowerCase();
            _value = valueToValidate;
        }
        else if(_field === "phone_number") valueToValidate = loginValues.country_code?.value + _value;
        else if(_field === "country_code") valueToValidate = _value + loginValues.phone_number?.value;
        const update = {
			...loginValues,
			[_field]: {error: validationMapping[_field].validate(valueToValidate) ? "" : validationMapping[_field].error(valueToValidate), value: _value},
            ...(_field === "country_code" ? 
                {"phone_number": 
                    {
                        value: loginValues?.phone_number?.value, 
                        error: validationMapping[_field].validate(valueToValidate) ? "" : validationMapping[_field].error(valueToValidate)
                    }
                } : {}
            )
        }
		setIsDisabled(!loginValidation(update));
		setLoginValues(update);
    }

    const handleFocus = () => {}

    const loginValidation=(update)=> {
		let isValid=true;
		let entries = [...Object.entries(update)]
		
		for(var [key, val] of entries) {
            let valueToValidate = val.value;
            if(key === "phone_number") {
                const countryCode = entries.find(elem => elem[0] === 'country_code')?.[1]?.value
                valueToValidate = countryCode + valueToValidate;
            } else if(key === "country_code") {
                const phoneNumber = entries.find(elem => elem[0] === 'phone_number')?.[1]?.value
                valueToValidate = valueToValidate + phoneNumber;
            }

			if(!validationMapping[key].validate(valueToValidate)) {
				isValid = false
			}
		}
		
        return isValid;
    }
    const handleUserPhoneNumberUpdate=async()=>{
        try{
            const payload = {
                number: loginValues?.country_code?.value + loginValues?.phone_number?.value,
            };
            const response = await JService.patch("/api/v1/auth/update-userphonenumber/", JSON.stringify(payload));
            if (!response?.success)
			throw new Error(
				response?.message || "Failed to update phone number. "
			);
        }
        catch(err){
            throw new Error(err);
        }
    }
    
    const handleUserNameUpdate= async() => {
        try{
            const data = {
                first_name: loginValues?.first_name?.value,
                last_name: loginValues?.last_name?.value,
            };
            const response = await JService.patch(API_BASE_URL + "/api/v1/auth/update-user/", JSON.stringify(data));
            console.log(response);
			if (!response?.success)
				throw new Error(
				response?.message || "Failed to update user name. "
				);
		}
        catch(err){
            console.log(err)
            throw new Error(err);
        }
    } 
    
    const handleLoginSubmit = async (e) => {
        try{
        e.preventDefault();
        console.log("in validate code")
        dispatch(loginAttempt(loginValues))

        const res = await fetch(API_BASE_URL + '/api/v1/auth/validate-code/?webapp=True', {
            method:'post',
            body: JSON.stringify({email:loginValues?.email?.value, code:loginValues?.password?.value, source: 'invite'}),
            headers: {
                'Content-Type': 'application/json',
            },
			credentials: "include",
        });
        if(res?.status === 500) throw new Error('Server error please try again or if issue persists contact FreJun.')
        const response = await res.json();
        if(!response?.success) throw new Error(response?.message || 'Failed to use entered invitation code. ')
                
				dispatch(loginAttempt({email: loginValues?.email?.value}))

				
                await handleUserNameUpdate()
                await handleUserPhoneNumberUpdate()
                navigate('/forgot-password/reset',{state:{from:'invite'}})
        }
        catch(err){
            console.log(err);
            enqueueSnackbar(err?.message || 'Failed to use entered invitation code. ', { variant: "error"})
        }
        finally{
                    setLoginValues({
                        first_name: {value:'',error:null},
                        last_name: {value:'',error:null},
                        email: {value:'',error:null},
                        password: {value:'',error:null},
                        phone_number:{value:'',error:null},
                        country_code:{value:'+91',error:null}
                        })
                }   
    }

    return(
		<div className='signup-container'>
			<div className='signup-art'>
			<a href="https://frejun.com/" target="_blank" rel="noopener noreferrer"> <img src={logo} alt="Logo" /></a>
				<img src={ dotsTop } alt=""/>
				<img style={{width: "60vmin"}} src={ vectorArt } alt=""/>
				<img src={ dotsBottom } alt=""/>
				<p className='regular-font px-18'>Simplify and Automate<br/>Your Calling Process</p>
			</div>
			<div className='signup-form'>
                <div className='logo-container'>
                    <img className='logo-image' onClick={() => window.location.href = "https://frejun.com/"} src={logo} alt="Logo" style={{ cursor: 'pointer' }} />
                </div>
				<p style={{marginTop:0}} className='title medium-font px-22'>Log in with your invite code</p>
				<form onSubmit={e => handleLoginSubmit(e)}>
					<div className='name-container'>
					<CustomInput value={loginValues?.first_name} label="First name" handleChange={handleLoginChange} handleFocus={handleFocus} name="first_name" type="text"/>
					<CustomInput value={loginValues?.last_name} label="Last name" handleChange={handleLoginChange} handleFocus={handleFocus} name="last_name" type="text"/>
					</div>
					<CustomInput value={loginValues?.email} label="Email" handleFocus={handleFocus} handleChange={handleLoginChange} name="email" type="text"/>
					<CustomInput dropdown={<CCDropdown selectedCountryCode={loginValues.country_code?.value} handleCountrySelect={(val)=>handleLoginChange(null, 'country_code', val)}/>} value={loginValues?.phone_number} label="Phone number" handleFocus={handleFocus} handleChange={handleLoginChange} name="phone_number" type='tel' />
					<CustomInput value={loginValues?.password} label="Invite code" handleFocus={handleFocus} handleChange={handleLoginChange} name="password" type="password"/>
					<Button disabled={isDisabled} icon={{startIcon: null, endIcon: null}}  hierarchy='green' variant='contained' buttonText='Log in' isLoading={false} onClick={handleLoginSubmit} styleOverride={{width: '100%',marginTop:'32px'}}/>
				</form>
			</div>
		</div>
    )
}

export default Invite;
